import type { QuoteAcceptedEvent } from "@@/shared/quotes/quote-events/quote-accepted.event";
import { quoteAcceptedEventZodSchema } from "@@/shared/quotes/quote-events/quote-accepted.event";
import type { QuoteCreatedEvent } from "@@/shared/quotes/quote-events/quote-created.event";
import { quoteCreatedEventZodSchema } from "@@/shared/quotes/quote-events/quote-created.event";
import type { QuoteDeletedEvent } from "@@/shared/quotes/quote-events/quote-deleted.event";
import { quoteDeletedEventZodSchema } from "@@/shared/quotes/quote-events/quote-deleted.event";
import type { QuotePublishedEvent } from "@@/shared/quotes/quote-events/quote-published.event";
import { quotePublishedEventZodSchema } from "@@/shared/quotes/quote-events/quote-published.event";
import type { QuoteUpdatedEvent } from "@@/shared/quotes/quote-events/quote-updated.event";
import { quoteUpdatedEventZodSchema } from "@@/shared/quotes/quote-events/quote-updated.event";
import type { QuoteViewedEvent } from "@@/shared/quotes/quote-events/quote-viewed.event";
import { quoteViewedEventZodSchema } from "@@/shared/quotes/quote-events/quote-viewed.event";
import { z } from "zod";

type QuoteEvent =
    | QuoteCreatedEvent
    | QuoteUpdatedEvent
    | QuoteAcceptedEvent
    | QuotePublishedEvent
    | QuoteDeletedEvent
    | QuoteViewedEvent;

type QuoteType = QuoteEvent["type"];

const quoteEventZodSchema: z.ZodSchema<QuoteEvent> = z.union([
    quoteCreatedEventZodSchema,
    quoteUpdatedEventZodSchema,
    quoteAcceptedEventZodSchema,
    quotePublishedEventZodSchema,
    quoteDeletedEventZodSchema,
    quoteViewedEventZodSchema,
]);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isQuote = (event: any): event is QuoteEvent => {
    return event?._type === "QUOTE_EVENT";
};
export { isQuote, quoteEventZodSchema };
export type { QuoteEvent, QuoteType };
